import { GridSortModel } from '@mui/x-data-grid';

const sortMapper = (sortKey: string) => {
  switch (sortKey) {
    case 'dateOfLoss':
      return 'lossDateSort';
    case 'dateOfNotice':
      return 'noticeDateSort';
    case 'appointment':
      return 'appointmentDateSort';
    case 'taskReceived':
      return 'receivedDateSort';
    case 'lossCity':
      return 'citySort';
    case 'lossCounty':
      return 'countySort';
    case 'lossState':
      return 'stateSort';
    case 'lossZip':
      return 'lossZipSort';
    case 'name':
      return 'nameSort';
    case 'state':
      return 'stateSort';
    case 'location':
      return 'locationSort';
    case 'isWorkTeam':
      return 'workTeamSort';
    default:
      return;
  }
};

type SORT =
  | 'lossDateSort'
  | 'noticeDateSort'
  | 'appointmentDateSort'
  | 'receivedDateSort'
  | 'citySort'
  | 'countySort'
  | 'stateSort'
  | 'lossZipSort'
  | 'nameSort'
  | 'locationSort'
  | 'workTeamSort'
  | undefined;

export const parseSort = (sortItems?: GridSortModel[number] | null) => {
  if (!sortItems) return;
  const parseSorting = Object.values(sortItems);
  const sortKey: SORT = sortMapper(parseSorting[0]);
  const direction = parseSorting[1];
  if (!sortKey) return;
  return { [sortKey]: direction };
};
